export default class TrashOptimizeModal {
  constructor(modal) {
    this.modal = modal;
    this.isOpen = false;
    this.key = null;
    this.init();
  }

  init() {
    this.modalEvents();
  }

  modalEvents() {
    let closeBtn = this.modal.querySelector('.btn-close');
    let applyBtn = this.modal.querySelector('.btn-apply');
    let overlay = this.modal.querySelector('.trash-calculator-form-overlay');


    overlay.addEventListener('click', (e) => {
      e.preventDefault();
      this.close();
    } );

    closeBtn.addEventListener( 'click', (e) => {
      e.preventDefault();
      this.close();
    } );

    applyBtn.addEventListener( 'click', (e) => {
      e.preventDefault();

      let optimize = JSON.parse(this.modal.dataset.optimize);

      optimize.forEach( (o) => {
        document.getElementById('new-'+o).click();
      });



      this.close();
    } );

    document.addEventListener('keyup', (event) => {
      if (event.defaultPrevented) {
        return;
      }

      if(this.isOpen) {
        let key = event.key || event.keyCode;

        if (key === 'Escape' || key === 'Esc' || key === 27) {
          this.close();
        }
      }
    });

  }

  open() {
    this.modal.classList.add('open');
    this.isOpen = true;
    lockBodyScroll();
  }

  close() {
    this.modal.classList.remove('open');
    this.isOpen = false;
    unlockBodyScroll();
  }

  removeModal() {
    this.modal.remove();
  }
}

function lockBodyScroll() {
  const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
  const body = document.body;
  body.style.position = 'fixed';
  body.style.width = '100%';
  body.style.top = `-${scrollY}`;
}

function unlockBodyScroll() {
  const body = document.body;
  const scrollY = body.style.top;
  body.style.position = '';
  body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
}

window.addEventListener('scroll', () => {
  document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
});
